import PropTypes from "prop-types";

const _Navigation = PropTypes.shape({
  acf_fc_layout: PropTypes.string,
  navigation_fix_sticky: PropTypes.bool,
});

export const NavigationPropTypes = {
  data: PropTypes.oneOfType([_Navigation, PropTypes.any]),
};
